import { triggerAutoloader } from '../util/triggerAutoloader';
import { collectCandidateTags } from '../util/collectCandidateTags';
import { removePreventInitAttr } from '../util/removePreventInitAttr';

const tabsHandler = (nodeList: NodeListOf<HTMLElement>) => {
    const handleTabsChange = ({ detail }: CustomEvent<string>) => {
        const area: HTMLElement | null = document.getElementById(detail);
        if (area) {
            triggerAutoloader(area);
            const elements = collectCandidateTags(area);
            removePreventInitAttr(elements);
        }
    };

    const init = () => {
        Array.from(nodeList).forEach((node: HTMLElement) => node.addEventListener('onChange', handleTabsChange));
    };

    init();
};

export default tabsHandler;
